var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.22221H8.72222V3H2.5V9.22221ZM4.05556 4.55555H7.16667V7.66666H4.05556V4.55555Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16.9997H8.72222V10.7775H2.5V16.9997ZM4.05556 12.333H7.16667V15.4441H4.05556V12.333Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2778 3V9.22221H16.5001V3H10.2778ZM14.9445 7.66666H11.8334V4.55555H14.9445V7.66666Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5004 15.4441H14.9448V16.9997H16.5004V15.4441Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8334 10.7775H10.2778V12.333H11.8334V10.7775Z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3891 12.3333H11.8335V13.8889H13.3891V12.3333Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8334 13.8892H10.2778V15.4447H11.8334V13.8892Z",
    fill: "#FAFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3891 15.4441H11.8335V16.9997H13.3891V15.4441Z",
    fill: "#FAFAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9442 13.8892H13.3887V15.4447H14.9442V13.8892Z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9442 10.7775H13.3887V12.333H14.9442V10.7775Z",
    fill: "#FAFAFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5004 12.3333H14.9448V13.8889H16.5004V12.3333Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.5e39fbb72a3cba7b9b23f489f71099bd.svg";
export { ForwardRef as ReactComponent };